import { Graphics, Point, SCALE_MODES, WebGLRenderer } from "pixi.js";
import { BoosterRenderer } from "../../../game/Utils/BoosterRenderer";
import { BoosterNameEnum, BoosterTypeEnum, GameModel, InstrumentTypeEnum } from "../../../game/Models/GameModel";
import { ModelEvents, SoundManager } from "@denishussar/html5-game-engine";
import { SoundConstants } from "../../../game/Constants/Sounds";
import { SoundModel } from "../../../game/Models/SoundModel";
import { GameLogic } from "../GameLogic";
import { GameEvent, GameEventBoosterUse } from "../../../game/Constants/GameEvent";


export class BombBooster extends BoosterRenderer {
    constructor(
        private gameModel: GameModel,
        private soundManager: SoundManager,
        private gameLogic: GameLogic,
        private modelEvents: ModelEvents,
        renderer: WebGLRenderer
    ) {
        super(renderer, {
            width: gameModel.boosterBallThreadSize * 2,
            height: gameModel.boosterBallThreadSize * 2,
            scaleMode: SCALE_MODES.NEAREST,
            resolution: 1
        });
        this.createFill();
    }

    createFill() {
        const r = this.gameModel.boosterBallThreadSize;
        const circle = new Graphics(true);
        circle.beginFill(0x00ff00, 0.3);
        circle.drawCircle(r, r, r);
        this.container.addChild(circle);
        this.draw();
        this.renderTexture.baseTexture.scaleMode = SCALE_MODES.NEAREST;
        this.sprite.x = -10000;
        this.sprite.y = -10000;
        this.sprite.width = this.sprite.height = 2 * r * GameModel.pixelSize;

    }

    movePointer(x: number, y: number) {
        this.sprite.x = x * GameModel.pixelSize;
        this.sprite.y = y * GameModel.pixelSize;
        this.sprite.anchor.set(0.5, 0.5);
    }

    fill(x: number, y: number) {
        const pixels = this.boosterBallThereadFigure(x, y);

        if (pixels.length) {
            this.soundManager.play(SoundConstants.BOOSTER_BRUSH, false, SoundModel.fx);

            pixels.map((point: Point) => this.gameLogic.fillPixelByBooster(point.x, point.y));

            this.gameLogic.decBooster(BoosterTypeEnum.yarn);

            this.modelEvents.dispatch(this.gameModel, this.gameLogic.isFTUE ? GameEvent.tutorialBoosterUse : GameEvent.boosterUse, <GameEventBoosterUse>{
                boosterName: BoosterNameEnum.yarn,
                levelName: this.gameModel.picture.name,
                levelSize: this.gameModel.currentPictureWidth,
            });
        }

        this.gameLogic.setBoosterType(BoosterTypeEnum.none);
        this.gameLogic.setInstrumentType(InstrumentTypeEnum.hand);
    }

    private boosterBallThereadFigure(x: number, y: number): Point[] {
        const pixels: Point[] = [];
        const radius = this.gameModel.boosterBallThreadSize;

        for (let i = -radius; i < radius; i++) {
            const height = Math.round(Math.sqrt(radius * radius - i * i));
            for (let j = -height; j < height; j++) {
                pixels.push(new Point(i + x, j + y));
            }
        }

        pixels.sort((a, b) => (a.y > b.y) ? 1 : -1);
        pixels.pop();
        pixels.shift();

        return pixels;
    }
}
